<template>
  <label
    class="mb-0 block text-sm font-medium"
    :class="[
      {
        'text-danger-50': error,
        'text-neutral-90': disabled && !error,
        'text-neutral-40': !disabled && !error,
      },
    ]"
  >
    <slot></slot>
  </label>
</template>

<script lang="ts" setup>
//Props
withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: boolean;
  }>(),
  {
    disabled: false,
    error: false,
  },
);
</script>
